import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': '',
  'test': '',
  'demo': 'event-broker-api-demo.apigateway.co',
  'prod': 'event-broker-api-prod.apigateway.co',
  'production': 'event-broker-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PropertyPIITag = /*#__PURE__*/function (PropertyPIITag) {
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_CLEAN"] = 0] = "PROPERTY_PII_TAG_CLEAN";
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_PII"] = 1] = "PROPERTY_PII_TAG_PII";
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_PD"] = 2] = "PROPERTY_PII_TAG_PD";
  return PropertyPIITag;
}(PropertyPIITag || {});
var PropertyType = /*#__PURE__*/function (PropertyType) {
  PropertyType[PropertyType["PROPERTY_TYPE_STRING"] = 0] = "PROPERTY_TYPE_STRING";
  PropertyType[PropertyType["PROPERTY_TYPE_INT64"] = 1] = "PROPERTY_TYPE_INT64";
  PropertyType[PropertyType["PROPERTY_TYPE_DOUBLE"] = 2] = "PROPERTY_TYPE_DOUBLE";
  PropertyType[PropertyType["PROPERTY_TYPE_BOOL"] = 3] = "PROPERTY_TYPE_BOOL";
  PropertyType[PropertyType["PROPERTY_TYPE_TIMESTAMP"] = 4] = "PROPERTY_TYPE_TIMESTAMP";
  PropertyType[PropertyType["PROPERTY_TYPE_GEOPOINT"] = 5] = "PROPERTY_TYPE_GEOPOINT";
  PropertyType[PropertyType["PROPERTY_TYPE_STRUCT"] = 6] = "PROPERTY_TYPE_STRUCT";
  PropertyType[PropertyType["PROPERTY_TYPE_BYTES"] = 7] = "PROPERTY_TYPE_BYTES";
  return PropertyType;
}(PropertyType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BooleanOperator = /*#__PURE__*/function (BooleanOperator) {
  BooleanOperator[BooleanOperator["BOOLEAN_OPERATOR_AND"] = 0] = "BOOLEAN_OPERATOR_AND";
  BooleanOperator[BooleanOperator["BOOLEAN_OPERATOR_OR"] = 1] = "BOOLEAN_OPERATOR_OR";
  return BooleanOperator;
}(BooleanOperator || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var InvokeHTTPContentType = /*#__PURE__*/function (InvokeHTTPContentType) {
  InvokeHTTPContentType[InvokeHTTPContentType["INVOKE_HTTP_CONTENT_TYPE_PROTOBUF"] = 0] = "INVOKE_HTTP_CONTENT_TYPE_PROTOBUF";
  InvokeHTTPContentType[InvokeHTTPContentType["INVOKE_HTTP_CONTENT_TYPE_JSON"] = 1] = "INVOKE_HTTP_CONTENT_TYPE_JSON";
  return InvokeHTTPContentType;
}(InvokeHTTPContentType || {});
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
let Property$1 = class Property {
  static fromProto(proto) {
    let m = new Property();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$4(PropertyType, proto.type);
    }
    if (proto.properties) {
      m.properties = proto.properties.map(Property.fromProto);
    }
    if (proto.piiTag) {
      m.piiTag = enumStringToValue$4(PropertyPIITag, proto.piiTag);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.repeated !== 'undefined') {
      toReturn['repeated'] = this.repeated;
    }
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    if (typeof this.piiTag !== 'undefined') {
      toReturn['piiTag'] = this.piiTag;
    }
    return toReturn;
  }
};
class Schema {
  static fromProto(proto) {
    let m = new Schema();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(Property$1.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    return toReturn;
  }
}
class TypedStruct {
  static fromProto(proto) {
    let m = new TypedStruct();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = Schema.fromProto(proto.schema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FilterNode {
  static fromProto(proto) {
    let m = new FilterNode();
    m = Object.assign(m, proto);
    if (proto.equal) {
      m.equal = PropertyValue.fromProto(proto.equal);
    }
    if (proto.operator) {
      m.operator = Operator.fromProto(proto.operator);
    }
    if (proto.not) {
      m.not = FilterNode.fromProto(proto.not);
    }
    if (proto.missing) {
      m.missing = Property.fromProto(proto.missing);
    }
    if (proto.null) {
      m.null = Property.fromProto(proto.null);
    }
    if (proto.subset) {
      m.subset = PropertyValue.fromProto(proto.subset);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.equal !== 'undefined' && this.equal !== null) {
      toReturn['equal'] = 'toApiJson' in this.equal ? this.equal.toApiJson() : this.equal;
    }
    if (typeof this.operator !== 'undefined' && this.operator !== null) {
      toReturn['operator'] = 'toApiJson' in this.operator ? this.operator.toApiJson() : this.operator;
    }
    if (typeof this.not !== 'undefined' && this.not !== null) {
      toReturn['not'] = 'toApiJson' in this.not ? this.not.toApiJson() : this.not;
    }
    if (typeof this.missing !== 'undefined' && this.missing !== null) {
      toReturn['missing'] = 'toApiJson' in this.missing ? this.missing.toApiJson() : this.missing;
    }
    if (typeof this.null !== 'undefined' && this.null !== null) {
      toReturn['null'] = 'toApiJson' in this.null ? this.null.toApiJson() : this.null;
    }
    if (typeof this.subset !== 'undefined' && this.subset !== null) {
      toReturn['subset'] = 'toApiJson' in this.subset ? this.subset.toApiJson() : this.subset;
    }
    return toReturn;
  }
}
class Operator {
  static fromProto(proto) {
    let m = new Operator();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue$3(BooleanOperator, proto.operator);
    }
    if (proto.children) {
      m.children = proto.children.map(FilterNode.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    return toReturn;
  }
}
class Property {
  static fromProto(proto) {
    let m = new Property();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.property !== 'undefined') {
      toReturn['property'] = this.property;
    }
    return toReturn;
  }
}
class PropertyValue {
  static fromProto(proto) {
    let m = new PropertyValue();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.property !== 'undefined') {
      toReturn['property'] = this.property;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class RetryConfig {
  static fromProto(proto) {
    let m = new RetryConfig();
    m = Object.assign(m, proto);
    if (proto.maxAttempts) {
      m.maxAttempts = parseInt(proto.maxAttempts, 10);
    }
    if (proto.maxDoublings) {
      m.maxDoublings = parseInt(proto.maxDoublings, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.maxAttempts !== 'undefined') {
      toReturn['maxAttempts'] = this.maxAttempts;
    }
    if (typeof this.maxRetryDuration !== 'undefined') {
      toReturn['maxRetryDuration'] = this.maxRetryDuration;
    }
    if (typeof this.minBackoff !== 'undefined') {
      toReturn['minBackoff'] = this.minBackoff;
    }
    if (typeof this.maxBackoff !== 'undefined') {
      toReturn['maxBackoff'] = this.maxBackoff;
    }
    if (typeof this.maxDoublings !== 'undefined') {
      toReturn['maxDoublings'] = this.maxDoublings;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class JoinNode {
  static fromProto(proto) {
    let m = new JoinNode();
    m = Object.assign(m, proto);
    if (proto.equal) {
      m.equal = PropertyValue.fromProto(proto.equal);
    }
    if (proto.and) {
      m.and = JoinOperator.fromProto(proto.and);
    }
    if (proto.equalProperty) {
      m.equalProperty = PropertyMapping.fromProto(proto.equalProperty);
    }
    if (proto.equalLiteral) {
      m.equalLiteral = PropertyValue.fromProto(proto.equalLiteral);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.equal !== 'undefined' && this.equal !== null) {
      toReturn['equal'] = 'toApiJson' in this.equal ? this.equal.toApiJson() : this.equal;
    }
    if (typeof this.and !== 'undefined' && this.and !== null) {
      toReturn['and'] = 'toApiJson' in this.and ? this.and.toApiJson() : this.and;
    }
    if (typeof this.equalProperty !== 'undefined' && this.equalProperty !== null) {
      toReturn['equalProperty'] = 'toApiJson' in this.equalProperty ? this.equalProperty.toApiJson() : this.equalProperty;
    }
    if (typeof this.equalLiteral !== 'undefined' && this.equalLiteral !== null) {
      toReturn['equalLiteral'] = 'toApiJson' in this.equalLiteral ? this.equalLiteral.toApiJson() : this.equalLiteral;
    }
    return toReturn;
  }
}
class JoinOperator {
  static fromProto(proto) {
    let m = new JoinOperator();
    m = Object.assign(m, proto);
    if (proto.children) {
      m.children = proto.children.map(JoinNode.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.children !== 'undefined' && this.children !== null) {
      toReturn['children'] = 'toApiJson' in this.children ? this.children.toApiJson() : this.children;
    }
    return toReturn;
  }
}
class PropertyMapping {
  static fromProto(proto) {
    let m = new PropertyMapping();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leftProperty !== 'undefined') {
      toReturn['leftProperty'] = this.leftProperty;
    }
    if (typeof this.rightProperty !== 'undefined') {
      toReturn['rightProperty'] = this.rightProperty;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateEventTypeRequest {
  static fromProto(proto) {
    let m = new CreateEventTypeRequest();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = Schema.fromProto(proto.schema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.eventIdFormat !== 'undefined') {
      toReturn['eventIdFormat'] = this.eventIdFormat;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateSubscriptionRequest {
  static fromProto(proto) {
    let m = new CreateSubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.invoke) {
      m.invoke = Invoke.fromProto(proto.invoke);
    }
    if (proto.filter) {
      m.filter = CreateSubscriptionRequestFilter.fromProto(proto.filter);
    }
    if (proto.join) {
      m.join = proto.join.map(JoinType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.invoke !== 'undefined' && this.invoke !== null) {
      toReturn['invoke'] = 'toApiJson' in this.invoke ? this.invoke.toApiJson() : this.invoke;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.join !== 'undefined' && this.join !== null) {
      toReturn['join'] = 'toApiJson' in this.join ? this.join.toApiJson() : this.join;
    }
    return toReturn;
  }
}
class DeleteEventTypeRequest {
  static fromProto(proto) {
    let m = new DeleteEventTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteSubscriptionRequest {
  static fromProto(proto) {
    let m = new DeleteSubscriptionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    return toReturn;
  }
}
class EmitEventRequest {
  static fromProto(proto) {
    let m = new EmitEventRequest();
    m = Object.assign(m, proto);
    if (proto.event) {
      m.event = Event.fromProto(proto.event);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    return toReturn;
  }
}
class Event {
  static fromProto(proto) {
    let m = new Event();
    m = Object.assign(m, proto);
    if (proto.emittedAt) {
      m.emittedAt = new Date(proto.emittedAt);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.emittedAt !== 'undefined' && this.emittedAt !== null) {
      toReturn['emittedAt'] = 'toApiJson' in this.emittedAt ? this.emittedAt.toApiJson() : this.emittedAt;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class EventType {
  static fromProto(proto) {
    let m = new EventType();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = Schema.fromProto(proto.schema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.eventIdFormat !== 'undefined') {
      toReturn['eventIdFormat'] = this.eventIdFormat;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GetMultiEventTypeResponseEventTypeContainer {
  static fromProto(proto) {
    let m = new GetMultiEventTypeResponseEventTypeContainer();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = EventType.fromProto(proto.eventType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventType !== 'undefined' && this.eventType !== null) {
      toReturn['eventType'] = 'toApiJson' in this.eventType ? this.eventType.toApiJson() : this.eventType;
    }
    return toReturn;
  }
}
class CreateSubscriptionRequestFilter {
  static fromProto(proto) {
    let m = new CreateSubscriptionRequestFilter();
    m = Object.assign(m, proto);
    if (proto.where) {
      m.where = FilterNode.fromProto(proto.where);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined') {
      toReturn['filters'] = this.filters;
    }
    if (typeof this.where !== 'undefined' && this.where !== null) {
      toReturn['where'] = 'toApiJson' in this.where ? this.where.toApiJson() : this.where;
    }
    return toReturn;
  }
}
class ReplaceSubscriptionRequestFilter {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionRequestFilter();
    m = Object.assign(m, proto);
    if (proto.where) {
      m.where = FilterNode.fromProto(proto.where);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined') {
      toReturn['filters'] = this.filters;
    }
    if (typeof this.where !== 'undefined' && this.where !== null) {
      toReturn['where'] = 'toApiJson' in this.where ? this.where.toApiJson() : this.where;
    }
    return toReturn;
  }
}
class GetMultiEventTypeRequest {
  static fromProto(proto) {
    let m = new GetMultiEventTypeRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    return toReturn;
  }
}
class GetMultiEventTypeResponse {
  static fromProto(proto) {
    let m = new GetMultiEventTypeResponse();
    m = Object.assign(m, proto);
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(GetMultiEventTypeResponseEventTypeContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypes !== 'undefined' && this.eventTypes !== null) {
      toReturn['eventTypes'] = 'toApiJson' in this.eventTypes ? this.eventTypes.toApiJson() : this.eventTypes;
    }
    return toReturn;
  }
}
class GetSubscriptionRequest {
  static fromProto(proto) {
    let m = new GetSubscriptionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    return toReturn;
  }
}
class GetSubscriptionResponse {
  static fromProto(proto) {
    let m = new GetSubscriptionResponse();
    m = Object.assign(m, proto);
    if (proto.subscription) {
      m.subscription = Subscription.fromProto(proto.subscription);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscription !== 'undefined' && this.subscription !== null) {
      toReturn['subscription'] = 'toApiJson' in this.subscription ? this.subscription.toApiJson() : this.subscription;
    }
    return toReturn;
  }
}
class InvokeHTTP {
  static fromProto(proto) {
    let m = new InvokeHTTP();
    m = Object.assign(m, proto);
    if (proto.contentType) {
      m.contentType = enumStringToValue(InvokeHTTPContentType, proto.contentType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class HydratedEvent {
  static fromProto(proto) {
    let m = new HydratedEvent();
    m = Object.assign(m, proto);
    if (proto.event) {
      m.event = Event.fromProto(proto.event);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.event !== 'undefined' && this.event !== null) {
      toReturn['event'] = 'toApiJson' in this.event ? this.event.toApiJson() : this.event;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.subscriptionName !== 'undefined') {
      toReturn['subscriptionName'] = this.subscriptionName;
    }
    return toReturn;
  }
}
class Invoke {
  static fromProto(proto) {
    let m = new Invoke();
    m = Object.assign(m, proto);
    if (proto.http) {
      m.http = InvokeHTTP.fromProto(proto.http);
    }
    if (proto.pubsub) {
      m.pubsub = InvokePubsubTopic.fromProto(proto.pubsub);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.http !== 'undefined' && this.http !== null) {
      toReturn['http'] = 'toApiJson' in this.http ? this.http.toApiJson() : this.http;
    }
    if (typeof this.pubsub !== 'undefined' && this.pubsub !== null) {
      toReturn['pubsub'] = 'toApiJson' in this.pubsub ? this.pubsub.toApiJson() : this.pubsub;
    }
    return toReturn;
  }
}
class JoinTypeJoin {
  static fromProto(proto) {
    let m = new JoinTypeJoin();
    m = Object.assign(m, proto);
    if (proto.on) {
      m.on = JoinNode.fromProto(proto.on);
    }
    if (proto.keepProperties) {
      m.keepProperties = Object.keys(proto.keepProperties).reduce((obj, k) => {
        obj[k] = proto.keepProperties[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.on !== 'undefined' && this.on !== null) {
      toReturn['on'] = 'toApiJson' in this.on ? this.on.toApiJson() : this.on;
    }
    if (typeof this.keepProperties !== 'undefined' && this.keepProperties !== null) {
      toReturn['keepProperties'] = 'toApiJson' in this.keepProperties ? this.keepProperties.toApiJson() : this.keepProperties;
    }
    if (typeof this.as !== 'undefined') {
      toReturn['as'] = this.as;
    }
    if (typeof this.window !== 'undefined') {
      toReturn['window'] = this.window;
    }
    return toReturn;
  }
}
class JoinType {
  static fromProto(proto) {
    let m = new JoinType();
    m = Object.assign(m, proto);
    if (proto.leftJoin) {
      m.leftJoin = JoinTypeJoin.fromProto(proto.leftJoin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leftJoin !== 'undefined' && this.leftJoin !== null) {
      toReturn['leftJoin'] = 'toApiJson' in this.leftJoin ? this.leftJoin.toApiJson() : this.leftJoin;
    }
    return toReturn;
  }
}
class JoinTypeJoinKeepPropertiesEntry {
  static fromProto(proto) {
    let m = new JoinTypeJoinKeepPropertiesEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ListEventTypesRequest {
  static fromProto(proto) {
    let m = new ListEventTypesRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListEventTypesResponse {
  static fromProto(proto) {
    let m = new ListEventTypesResponse();
    m = Object.assign(m, proto);
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(EventType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypes !== 'undefined' && this.eventTypes !== null) {
      toReturn['eventTypes'] = 'toApiJson' in this.eventTypes ? this.eventTypes.toApiJson() : this.eventTypes;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class InvokePubsubTopic {
  static fromProto(proto) {
    let m = new InvokePubsubTopic();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gcpProject !== 'undefined') {
      toReturn['gcpProject'] = this.gcpProject;
    }
    if (typeof this.topicName !== 'undefined') {
      toReturn['topicName'] = this.topicName;
    }
    return toReturn;
  }
}
class ReplaceSubscriptionRequest {
  static fromProto(proto) {
    let m = new ReplaceSubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.invoke) {
      m.invoke = Invoke.fromProto(proto.invoke);
    }
    if (proto.filter) {
      m.filter = ReplaceSubscriptionRequestFilter.fromProto(proto.filter);
    }
    if (proto.join) {
      m.join = proto.join.map(JoinType.fromProto);
    }
    if (proto.retryConfig) {
      m.retryConfig = RetryConfig.fromProto(proto.retryConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.invoke !== 'undefined' && this.invoke !== null) {
      toReturn['invoke'] = 'toApiJson' in this.invoke ? this.invoke.toApiJson() : this.invoke;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.join !== 'undefined' && this.join !== null) {
      toReturn['join'] = 'toApiJson' in this.join ? this.join.toApiJson() : this.join;
    }
    if (typeof this.retryConfig !== 'undefined' && this.retryConfig !== null) {
      toReturn['retryConfig'] = 'toApiJson' in this.retryConfig ? this.retryConfig.toApiJson() : this.retryConfig;
    }
    return toReturn;
  }
}
class ReplaySubscriptionRequest {
  static fromProto(proto) {
    let m = new ReplaySubscriptionRequest();
    m = Object.assign(m, proto);
    if (proto.filter) {
      m.filter = FilterNode.fromProto(proto.filter);
    }
    if (proto.timeRange) {
      m.timeRange = ReplaySubscriptionRequestTimeRange.fromProto(proto.timeRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.latestEvents !== 'undefined') {
      toReturn['latestEvents'] = this.latestEvents;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.timeRange !== 'undefined' && this.timeRange !== null) {
      toReturn['timeRange'] = 'toApiJson' in this.timeRange ? this.timeRange.toApiJson() : this.timeRange;
    }
    return toReturn;
  }
}
class ReplaySubscriptionResponse {
  static fromProto(proto) {
    let m = new ReplaySubscriptionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statusUrl !== 'undefined') {
      toReturn['statusUrl'] = this.statusUrl;
    }
    return toReturn;
  }
}
class Subscription {
  static fromProto(proto) {
    let m = new Subscription();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.invoke) {
      m.invoke = Invoke.fromProto(proto.invoke);
    }
    if (proto.filter) {
      m.filter = ReplaceSubscriptionRequestFilter.fromProto(proto.filter);
    }
    if (proto.join) {
      m.join = proto.join.map(JoinType.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.owner !== 'undefined') {
      toReturn['owner'] = this.owner;
    }
    if (typeof this.eventTypeId !== 'undefined') {
      toReturn['eventTypeId'] = this.eventTypeId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.invoke !== 'undefined' && this.invoke !== null) {
      toReturn['invoke'] = 'toApiJson' in this.invoke ? this.invoke.toApiJson() : this.invoke;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.join !== 'undefined' && this.join !== null) {
      toReturn['join'] = 'toApiJson' in this.join ? this.join.toApiJson() : this.join;
    }
    return toReturn;
  }
}
class ReplaySubscriptionRequestTimeRange {
  static fromProto(proto) {
    let m = new ReplaySubscriptionRequestTimeRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
class UpdateEventTypeRequest {
  static fromProto(proto) {
    let m = new UpdateEventTypeRequest();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = Schema.fromProto(proto.schema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    return toReturn;
  }
}

// *********************************

// *********************************
let EventBrokerApiService = /*#__PURE__*/(() => {
  class EventBrokerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEventType(r) {
      const request = r.toApiJson ? r : new CreateEventTypeRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/CreateEventType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateEventType(r) {
      const request = r.toApiJson ? r : new UpdateEventTypeRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/UpdateEventType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteEventType(r) {
      const request = r.toApiJson ? r : new DeleteEventTypeRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/DeleteEventType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiEventType(r) {
      const request = r.toApiJson ? r : new GetMultiEventTypeRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/GetMultiEventType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiEventTypeResponse.fromProto(resp)));
    }
    listEventTypes(r) {
      const request = r.toApiJson ? r : new ListEventTypesRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/ListEventTypes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEventTypesResponse.fromProto(resp)));
    }
    emitEvent(r) {
      const request = r.toApiJson ? r : new EmitEventRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/EmitEvent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createSubscription(r) {
      const request = r.toApiJson ? r : new CreateSubscriptionRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/CreateSubscription", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceSubscription(r) {
      const request = r.toApiJson ? r : new ReplaceSubscriptionRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/ReplaceSubscription", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteSubscription(r) {
      const request = r.toApiJson ? r : new DeleteSubscriptionRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/DeleteSubscription", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaySubscription(r) {
      const request = r.toApiJson ? r : new ReplaySubscriptionRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/ReplaySubscription", request.toApiJson(), this.apiOptions()).pipe(map(resp => ReplaySubscriptionResponse.fromProto(resp)));
    }
    getSubscription(r) {
      const request = r.toApiJson ? r : new GetSubscriptionRequest(r);
      return this.http.post(this._host + "/eventbroker.v1.EventBroker/GetSubscription", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubscriptionResponse.fromProto(resp)));
    }
  }
  EventBrokerApiService.ɵfac = function EventBrokerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EventBrokerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  EventBrokerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EventBrokerApiService,
    factory: EventBrokerApiService.ɵfac,
    providedIn: 'root'
  });
  return EventBrokerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let EventBrokerService = /*#__PURE__*/(() => {
  class EventBrokerService {
    constructor(api) {
      this.api = api;
    }
    getEventTypes(eventTypeIds) {
      return this.api.getMultiEventType({
        eventTypeId: eventTypeIds
      }).pipe(map(resp => resp.eventTypes), map(containers => containers.map(container => container.eventType)));
    }
    listEventTypes(cursor, pageSize, searchTerm) {
      return this.api.listEventTypes({
        searchTerm: searchTerm,
        cursor: cursor,
        pageSize: pageSize
      }).pipe(map(r => ({
        eventTypes: r.eventTypes,
        nextCursor: r.nextCursor,
        hasMore: r.hasMore
      })));
    }
  }
  EventBrokerService.ɵfac = function EventBrokerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EventBrokerService)(i0.ɵɵinject(EventBrokerApiService));
  };
  EventBrokerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EventBrokerService,
    factory: EventBrokerService.ɵfac,
    providedIn: "root"
  });
  return EventBrokerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, BooleanOperator, CreateEventTypeRequest, CreateSubscriptionRequest, CreateSubscriptionRequestFilter, DeleteEventTypeRequest, DeleteSubscriptionRequest, EmitEventRequest, Event, EventBrokerApiService, EventBrokerService, EventType, FilterNode, GetMultiEventTypeRequest, GetMultiEventTypeResponse, GetMultiEventTypeResponseEventTypeContainer, GetSubscriptionRequest, GetSubscriptionResponse, HostService, HydratedEvent, Invoke, InvokeHTTP, InvokeHTTPContentType, InvokePubsubTopic, JoinNode, JoinOperator, JoinType, JoinTypeJoin, JoinTypeJoinKeepPropertiesEntry, ListEventTypesRequest, ListEventTypesResponse, Operator, Property, PropertyMapping, PropertyPIITag, PropertyType, PropertyValue, ReplaceSubscriptionRequest, ReplaceSubscriptionRequestFilter, ReplaySubscriptionRequest, ReplaySubscriptionRequestTimeRange, ReplaySubscriptionResponse, RetryConfig, Schema, Property$1 as SchemaProperty, Subscription, TypedStruct, UpdateEventTypeRequest };
